(() => {
  function init() {
    const shell = document.querySelector('.ebsi-course-hero');
    if (!shell || shell.dataset.ready) return;
    shell.dataset.ready = 'true';
    const intro = shell.querySelector('.ebsi-course-intro');
    const lead = intro.querySelector('[data-course-intro]');
    const mq = matchMedia('(max-width:749px)');
    const courseLink = intro.querySelector('a[href="#ebsi-course-description"]');
    const vitalsPanel = document.createElement('div');
    vitalsPanel.className = 'ebsi-course-vitals';
    const vitalsOrigins = new Map();
    const vitalsSelectors = ['.vtl-pl-main-widget', '.Vtl-WishlistButtonWrapper', '.vtl-tb-main-widget'];
    function placeVitals() {
      if (!courseLink || !shell.isConnected) return;
      const controls = shell.querySelector('.ebsi-course-controls');
      if (!controls) return;
      for (const [widget, origin] of vitalsOrigins) {
        if (!origin.isConnected || !widget.isConnected) {
          if (widget.parentNode === vitalsPanel) widget.remove();
          origin.remove();
          vitalsOrigins.delete(widget);
        }
      }
      // Move the original app widgets, retaining their content and event handlers.
      // Mark their original locations so mobile can restore the native layout.
      if (mq.matches) {
        for (const [widget, origin] of vitalsOrigins) {
          if (origin.isConnected && widget.parentNode === vitalsPanel) origin.after(widget);
        }
        return;
      }
      for (const selector of vitalsSelectors) {
        for (const widget of controls.querySelectorAll(selector)) {
          let origin = vitalsOrigins.get(widget);
          if (!origin?.isConnected) {
            origin = document.createComment('eBSI Vitals mobile position');
            widget.before(origin);
            vitalsOrigins.set(widget, origin);
          }
          if (!vitalsPanel.isConnected) courseLink.after(vitalsPanel);
          vitalsPanel.append(widget);
        }
      }
    }
    function arrange() {
      if (mq.matches) { lead.classList.add('ebsi-course-lead-mobile'); shell.append(lead); }
      else { lead.classList.remove('ebsi-course-lead-mobile'); intro.insertBefore(lead, intro.querySelector('a')); }
      placeVitals();
    }
    arrange();
    mq.addEventListener('change', arrange);
    function placeRating() {
      placeVitals();
      const rating = document.querySelector('.bundle-aggregated_reviews');
      if (rating && !intro.contains(rating)) intro.querySelector('h1').after(rating);
      const controls = document.querySelector('.ebsi-course-controls');
      const mainPrice = controls?.querySelector('product-price .price');
      const stickyPrice = document.querySelector('.Vtl-StickyAddToCart__ProductPriceCurrent .money');
      if (controls?.querySelector('.sls-selling-plan-group-first-line') && mainPrice && stickyPrice && stickyPrice.textContent.trim() !== mainPrice.textContent.trim()) stickyPrice.textContent = mainPrice.textContent.trim();
      if (document.documentElement.lang.startsWith('en')) {
        for (const button of document.querySelectorAll('.ebsi-course-controls button[name="add"],#bundle-sticky_submit .Vtl-StickyAddToCart__AddToCartButtonClonedContent')) {
          for (const node of button.childNodes) if (node.nodeType === 3 && node.textContent.trim() === 'Add to cart') node.textContent = 'Enrol now';
        }
      }
    }
    placeRating();
    const observer = new MutationObserver(placeRating);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    window.addEventListener('click', event => {
      if (!event.target.closest('#bundle-sticky_submit')) return;
      const controls = document.querySelector('.ebsi-course-controls');
      if (!controls?.querySelector('.sls-selling-plan-group-first-line')) return;
      const button = controls.querySelector('button[name="add"]');
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const stickyQuantity = document.querySelector('#sticky-add-to-cart-quantity');
      const quantity = controls.querySelector('input[name="quantity"]');
      if (stickyQuantity && quantity) { quantity.value = stickyQuantity.value; quantity.dispatchEvent(new Event('change', { bubbles: true })); }
      if (!button.disabled) button.closest('form')?.requestSubmit(button);
    }, true);
    const source = document.querySelector('[data-course-description]');
    if (source) {
      const candidates = [...source.querySelectorAll('p,h2,h3,h4,h5')].filter(el => /^Module\s+(?:\w+|\d+)\s*:/i.test(el.textContent.trim()) && !el.closest('details'));
      for (const el of candidates) {
        if (!el.isConnected) continue;
        const details = document.createElement('details'), summary = document.createElement('summary'), body = document.createElement('div');
        summary.textContent = el.textContent.trim();
        details.append(summary, body);
        el.before(details);
        let next = el.nextSibling;
        while (next) {
          if (next.nodeType === 1 && (/^Module\s+(?:\w+|\d+)\s*:/i.test(next.textContent.trim()) || next.matches('h2,h3,h4,h5,.ebsi-cross-sell,.ebsi-course-pathway,hr'))) break;
          const following = next.nextSibling;
          body.append(next);
          next = following;
        }
        el.remove();
      }
    }
    document.querySelectorAll('[data-course-enrol]').forEach(b => b.addEventListener('click', () => {
      const button = document.querySelector('.ebsi-course-controls button[name="add"]');
      if (button) {
        button.scrollIntoView({ behavior: 'smooth', block: 'center' });
        button.focus({ preventScroll: true });
        if (!button.disabled) button.closest('form')?.requestSubmit(button);
      }
    }));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();